<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'MiningSetting'
};
</script>

<style lang="less" scoped></style>
